import React from "react";

interface IProps {
  variant?: "primary" | "danger" | "information";
  size?: "small" | "large";
  fill?: boolean;
}

export const InformationIcon = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`h-6 w-6 ${computeColor(props.variant)}${props.fill && " fill-current"}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

InformationIcon.Solid = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${props.size === "small" ? "h-4 w-4" : "h-12 w-12"} ${computeColor(
        props.variant
      )}${props.fill && " fill-current"}`}
      fill="none"
      viewBox="0 0 24 25"
      stroke="currentColor"
    >
      <path d="M12.15 0.349976C9.74696 0.349976 7.39788 1.06256 5.39983 2.39762C3.40177 3.73268 1.84447 5.63025 0.924869 7.85037C0.00526442 10.0705 -0.235346 12.5135 0.233464 14.8703C0.702275 17.2272 1.85945 19.3921 3.55866 21.0913C5.25787 22.7905 7.42279 23.9477 9.77966 24.4165C12.1365 24.8853 14.5795 24.6447 16.7996 23.7251C19.0197 22.8055 20.9173 21.2482 22.2524 19.2502C23.5874 17.2521 24.3 14.903 24.3 12.5C24.3 9.2776 23.0199 6.1872 20.7414 3.90863C18.4628 1.63006 15.3724 0.349976 12.15 0.349976ZM14.1857 18.1905C13.4958 19.1636 12.8052 19.8312 12.0623 20.2044C11.5241 20.4673 10.9298 20.5944 10.3312 20.5746C8.76162 20.4447 8.03234 19.2617 8.71726 17.38L10.7808 11.7105C11.2261 10.487 10.7945 10.1149 10.4413 10.1052C10.021 10.0975 9.51849 10.4914 8.9338 11.2868C8.88592 11.3538 8.81343 11.3991 8.73221 11.4128C8.65099 11.4264 8.56767 11.4073 8.50048 11.3597C8.4333 11.3121 8.38774 11.2397 8.37377 11.1586C8.3598 11.0774 8.37857 10.994 8.42597 10.9267C9.11593 9.95355 9.80656 9.28596 10.5494 8.9127C11.0876 8.64988 11.6819 8.52278 12.2805 8.54251C13.8501 8.6724 14.5794 9.85543 13.8945 11.7371L11.831 17.4066C11.3856 18.6302 11.8173 19.0022 12.1704 19.0119C12.5907 19.0196 13.0932 18.6258 13.6779 17.8304C13.7258 17.7633 13.7983 17.718 13.8795 17.7044C13.9607 17.6907 14.0441 17.7098 14.1112 17.7574C14.1784 17.8051 14.224 17.8774 14.2379 17.9586C14.2519 18.0397 14.2331 18.1231 14.1857 18.1905V18.1905ZM15.8411 6.38882C15.7418 6.66156 15.5639 6.89874 15.3298 7.07036C15.0957 7.24198 14.816 7.34033 14.5261 7.35299C14.2361 7.36565 13.9489 7.29204 13.7008 7.14146C13.4526 6.99089 13.2547 6.77012 13.1321 6.50706C13.0094 6.24401 12.9675 5.95049 13.0117 5.66363C13.0558 5.37676 13.184 5.10943 13.3801 4.89544C13.5762 4.68145 13.8314 4.53042 14.1133 4.46143C14.3952 4.39245 14.6913 4.40861 14.964 4.50788C15.1451 4.57379 15.3114 4.67473 15.4535 4.80493C15.5956 4.93512 15.7107 5.09203 15.7921 5.2667C15.8736 5.44136 15.9198 5.63035 15.9282 5.82289C15.9366 6.01542 15.907 6.20773 15.8411 6.38882Z" />
    </svg>
  );
};

const computeColor = (variant: IProps["variant"]) => {
  switch (variant) {
    case "primary":
    default:
      return "text-primary-900";
    case "information":
      return "text-tertiary-200";
    case "danger":
      return "text-red-500";
  }
};
